// extracted by mini-css-extract-plugin
export default {"content":"gtFDI","doubleCol":"wsxKo"};